import { Link } from 'react-router-dom';

const NetworkSystems = () => {
  return (
    <>
      <section className="page-intro">
        <div className="container">
          <h1>Network Systems Solutions</h1>
          <p>
            Delivering intelligent networks that are designed for high availability, zero-trust security, and seamless
            user experiences across hybrid environments.
          </p>
        </div>
      </section>

      <section className="content-section">
        <div className="container split">
          <div className="text-block">
            <h2>Architected for Resilience</h2>
            <p>
              Our certified engineers design and implement wired, wireless, and software-defined networks that support
              mission-critical workloads. We ensure secure segmentation, visibility, and simplified operations.
            </p>
            <ul className="checklist">
              <li>Core, distribution, and access networking</li>
              <li>Software-defined networking and automation</li>
              <li>Enterprise Wi-Fi, guest access, and location services</li>
              <li>WAN optimization and multi-cloud connectivity</li>
            </ul>
          </div>
          <div className="service-card">
            <h3>Security-First Networking</h3>
            <ul>
              <li>Zero-trust architecture and identity-based policy enforcement</li>
              <li>Integrated firewalls, intrusion prevention, and advanced threat detection</li>
              <li>Network access control and posture validation</li>
              <li>Continuous monitoring with real-time analytics</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section alt">
        <div className="container">
          <div className="section-header">
            <span className="tagline">Lifecycle Services</span>
            <h2 className="section-title">From Strategy to Managed Operations</h2>
          </div>
          <div className="service-grid">
            <article className="service-card">
              <h3>Assessment &amp; Design</h3>
              <p>Network readiness assessments, architecture definition, and capacity planning.</p>
            </article>
            <article className="service-card">
              <h3>Implementation</h3>
              <p>Configuration, deployment, migration, and testing support delivered by certified experts.</p>
            </article>
            <article className="service-card">
              <h3>Optimization</h3>
              <p>Performance tuning, QoS strategies, and policy refinement for evolving workloads.</p>
            </article>
            <article className="service-card">
              <h3>Managed Services</h3>
              <p>Proactive monitoring, incident response, and SLA-backed operations management.</p>
            </article>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2>Plan Your Network Evolution</h2>
              <p>Engage Nexus IT to modernize your network with secure, software-defined architectures.</p>
            </div>
            <Link className="btn btn-primary" to="/contact">
              Consult with Experts
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default NetworkSystems;
